// <s-cart-timer> counts down a cart reservation window shared across page loads and cart partial swaps.
const STORAGE_KEY = 'cart-timer-end';

class SCartTimer extends HTMLElement {
  #intervalId = 0;

  connectedCallback() {
    this.output = this.querySelector('[data-timer]');
    if (!this.output) return;

    this.durationMs = Math.max(1, Number(this.dataset.minutes) || 5) * 60 * 1000;
    this.#tick();
    this.#intervalId = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#intervalId);
  }

  #readEnd() {
    try {
      return Number(sessionStorage.getItem(STORAGE_KEY)) || 0;
    } catch {
      return this.fallbackEnd || 0;
    }
  }

  #writeEnd(end) {
    this.fallbackEnd = end;
    try {
      sessionStorage.setItem(STORAGE_KEY, String(end));
    } catch {
      // Storage can be unavailable in private modes; the in-memory fallback keeps the countdown running.
    }
  }

  #tick() {
    let end = this.#readEnd();
    const now = Date.now();
    // An expired or missing window starts a fresh reservation so the countdown never shows negative time.
    if (!end || end <= now || end - now > this.durationMs) {
      end = now + this.durationMs;
      this.#writeEnd(end);
    }
    const remaining = Math.max(0, Math.round((end - now) / 1000));
    const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
    const seconds = String(remaining % 60).padStart(2, '0');
    this.output.textContent = `${minutes}:${seconds}`;
  }
}

if (!customElements.get('s-cart-timer')) customElements.define('s-cart-timer', SCartTimer);
